import React, { useEffect, useRef, useState } from 'react'

const questions = [
	{
		text: "What is your experience as a tutor / teacher?",
		answers: [
			"None, just getting started",
			"I've had some students as a side hustle",
			"I'm a certified teacher with some experience (1-3 yrs)",
			"I'm a certified teacher with years of experience (+3yrs)",
			"I'm not certified with some experience",
			"I'm not certified with a lot of experience",
		],
		replies: [
			"DO YOU HAVE KNOWLEDGE YOU CAN SHARE WITH THE WORLD, OR ARE YOU PASSIONATE ABOUT A TOPIC OR A HOBBY? IF SO, YOU CAN BUILD YOUR OWN ONLINE BUSINESS AROUND IT.",
			"GREAT, YOU'VE ALREADY STARTED AND HAVE SOME EXPERIENCE. YOUR NEXT STEP IS TO LEARN HOW TO BUILD A SOLID CLIENTS BASE, AND TURN YOUR SIDE HUSTLE INTO A STABLE INCOME SOURCE.",
			"GREAT, YOU ALREADY HAVE THE NECESSARY SKILLS AND EXPERIENCE TO GO INDEPENDENT AND BUILD YOUR OWN BUSINESS. ",
			"GREAT, YOU ALREADY HAVE THE NECESSARY SKILLS AND EXPERIENCE TO GO INDEPENDENT AND BUILD YOUR OWN BUSINESS.",
			"GREAT, YOU ALREADY HAVE THE NECESSARY SKILLS AND EXPERIENCE TO GO INDEPENDENT AND BUILD YOUR OWN BUSINESS.",
			"GREAT, YOU ALREADY HAVE THE NECESSARY SKILLS AND EXPERIENCE TO GO INDEPENDENT AND BUILD YOUR OWN BUSINESS.",
		]
	}, {
		text: "What do you teach?",
		answers: [
			"Language",
			"Business skills",
			"Health, Sports, Nutrition",
			"School subjects ",
			"Certification exam preparation",
			"Design & Arts",
			"Music",
			"others",
		],
		replies: [
			"AS A LANGUAGE TEACHER, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"AS A BUSINESS COACH, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"AS AN EXPERT IN HEALTH, SPORTS & NUTRITION, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"AS A SCHOOL TEACHER, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"WITH YOUR EXPERIENCE IN EXAM PREPARATION, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"WITH YOUR EXPERIENCE IN DESIGN & ARTS, YOIU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"AS A MUSIC TEACHER, WETHER YOU FOCUS ON SINGING, COMPOSING, OR INSTRUMENTS, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
			"AS AN AFICIONADO AND EXPERT IN YOUR FIELD, YOU HAVE VARIOUS OPTIONS TO BOOST YOUR CAREER AND GROW YOUR INCOME.",
		]
	}, {
		text: "Who do you want to teach?",
		answers: [
			"kids up to 12 years",
			"kids and teenagers",
			"High school and College",
			"adults ",
			"+65 years",
			"all ages",
		],
		replies: [
			"HELPING KIDS TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THE LITTLE ONES THRIVE.",
			"HELPING YOUNG LEARNERS TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THEM THRIVE.",
			"HELPING YOUNG PEOPLE TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THEM THRIVE.",
			"HELPING PEOPLE TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THEM THRIVE.",
			"HELPING PEOPLE TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THEM THRIVE.",
			"HELPING PEOPLE TO GROW IS REWARDING BUT CAN BE DRAINING IF THE CIRCUMSTANCES AREN'T RIGHT. GOING INDEPENDENT MEANS TO WORK WITH MOTIVATED STUDENTS ALL OVER THE WORLD, TEACH YOUR OWN LESSONS, AND SEE THEM THRIVE.",
		]
	}, {
		text: "In which countries do your students live?",
		answers: [],
		replies: []
	}, {
		text: "How many languages do you speak?",
		answers: [
			"one",
			"two",
			"three",
			"more than 3",
		],
		replies: [
			"THAT'S GREAT, LET'S FIND YOUR POTENTIAL CLIENTS.",
			"AS A BILINGUAL PERSON, YOU HAVE THE OPPORTUNITY TO TARGET POTENTIAL CLIENTS IN DIFFERENT COUNTRIES.",
			"AS A MULTILINGUAL PERSON, YOU HAVE THE OPPORTUNITY TO TARGET POTENTIAL CLIENTS IN DIFFERENT COUNTRIES.",
			"AS A MULTILINGUAL PERSON, YOU HAVE THE OPPORTUNITY TO TARGET POTENTIAL CLIENTS IN DIFFERENT COUNTRIES.",
		]
	}, {
		text: "Are you looking to work full time or part time?",
		answers: [
			"full time",
			"part time",
			"Just a small side hustle",
		],
		replies: [
			"WETHER YOU PLAN TO WORK INDEPENDENTLY PART TIME OR FULL TIME, OR ARE LOOKING FOR A TIME EFFECTIVE SIDE HUSTLE, BUILDING YOUR OWN PLATFORM ISN'T DIFFICULT.",
		]
	}, {
		text: "How much money do you want to make?",
		answers: [
			"I'm okay with $1000 monthly income",
			"Between $1k- $2k a month",
			"My goal income is between $2k- $5k monthly income",
			"I want to scale my tutor business to $10k and beyond",
		],
		replies: [
			"ONCE YOU GET STARTED WORKING PART TIME, YOU WILL GENERATE AN AVERAGE INCOME OF $1,000 - $2,000 PER MONTH.",
			"ONCE YOU GET STARTED WORKING PART TIME, YOU WILL GENERATE AN AVERAGE INCOME OF $1,000 - $2,000 PER MONTH.",
			"ONCE YOU GET STARTED WORKING FULL TIME, YOU WILL GENERATE AN AVERAGE INCOME OF $2,000 - $5,000 PER MONTH.",
			"ONCE YOU GET STARTED TEACHING WEBINARS FULL TIME, YOU WILL GENERATE AN AVERAGE INCOME OF $10,000 OR MORE PER MONTH.",
		]
	}, {
		text: "How much time do you want to invest to become independent?",
		answers: [
			"ASAP",
			"3 months",
			"3-6 months",
			"I have no deadline",
		],
		replies: [
			"YOU CAN START RIGHT AWAY AND ENROLL IN THE PROGRAM IF YOU NEED A STABLE INCOME FAST. LET'S GET TO WORK!",
			"IN ORDER TO GENERATE INCOME WITH YOUR ONLINE BUSINESS IN 3 MONTHS, YOU ENROLL IN THE PROGRAM AND WE BUILD YOUR BUSINESS TOGETHER, STEP BY STEP. ",
			"IN ORDER TO GENERATE INCOME WITH YOUR ONLINE BUSINESS IN 3-6 MONTHS, YOU ENROLL IN THE PROGRAM, WE DEFINE YOUR GOALS, SET MILESTONES, AND BUILD YOUR BUSINESS TOGETHER.",
			"YOU MIGHT NOT HAVE A DEADLINE, BUT IN ORDER TO GENERATE INCOME WITH YOUR ONLINE BUSINESS FAST, WE WILL DEFINE YOUR GOALS AND SET MILESTONES IN THE 4VWEEKS TRAINING PHASE, AND BUILD YOUR BUSINESS TOGETHER IN THE MENTORSHIP PHASE.",
		]
	}, {
		text: "How are your marketing skills?",
		answers: [
			"I know nothing",
			"I have a basic understanding of marketing my services",
			"I'm a good marketer",
		],
		replies: [
			"ONE OF THE NECESSARY SKILLS AS AN INDEPENDENT TEACHER OR COACH IS MARKETING, AS WELL AS PERSONAL BRANDING. DON'T WORRY IF YOU HAVE NEVER MARKETED YOURSELF, YOU WILL LEARN EVERYTHING YOU NEED IN THE TRAINING PHASE.",
			"ONE OF THE NECESSARY SKILLS AS AN INDEPENDENT TEACHER OR COACH IS MARKETING, AS WELL AS PERSONAL BRANDING. DON'T WORRY IF YOU HAVE LITTLE EXPERIENCE MARKETING YOURSELF, YOU WILL LEARN EVERYTHING YOU NEED IN THE TRAINING PHASE.",
			"APPLYING YOUR MARKETING SKILLS WILL HELP YOU REACH YOUR GOALS AS A SUCCESSFUL INDEPENDENT TEACHER OR COACH MUCH EASIER. YOU WILL LEARN EVERYTHING YOU NEED IN THE TRAINING PHASE, FROM CONTENT MARKETING, TO COPYWRITING, AND PERSONAL BRANDING.",
		]
	}, {
		text: "If you are already working as a tutor, how do you market yourself?",
		answers: [
			"I have a website / landing page",
			"I use social media to attract new students",
			"I run ads",
			"I make podcasts",
			"Email list",
			"others",
			"I don't market myself at all",
		],
		replies: []
	}, {
		text: "Why do you want to become an independent online tutor?",
		answers: [
			"I want more personal freedom",
			"A flexible schedule is important for me ",
			"More time for family",
			"Work from anywhere",
			"I want to be my own boss",
			"I love teaching and helping others grow",
			"Financial stability",
			"I'm looking for a career change",
			"I want to grow professionally",
			"I hate my current job",
			"I feel trapped in my current job",
			"I have no stable job or income, and I want to change that",
		],
		replies: [
			"BUILDING YOUR OWN INDEPENDENT ONLINE BUSINESS MEANS MORE FREEDOM: PERSONALLY, FINANCIALLY, PROFESSIONALLY. YOU CAN WORK FROM ANYWHERE, SET YOUR OWN SCHEDULE, TRAVEL, OR BE CLOSER TO YOUR FAMILY. ONLINE TEACHING IS THE PERFECT CAREER TO PRIORITISE YOUR LIFE AND HAPPINESS OVER YOUR JOB. IF YOU FEEL TRAPPED, UNDERVALUED, AND FRUSTRATED IN YOUR CURRENT WORK PLACE, THIS PROGRAM WILL HELP YOU TURN YOUR CAREER AND LIFE AROUND."
		]
	}, {
		text: "How do you want to teach?",
		answers: [
			"one 2 one online",
			"one 2 one presential",
			"small groups online",
			"small groups presential",
			"big groups +10 students online",
			"big groups +10 students presential",
			"audiences of +50 students online",
		],
		replies: [
			(<>NO MATTER IF YOU PREFER WORKING 1-2-1, IN SMALL GROUPS, OR TEACHING A BIGGER AUDIENCE IN WEBINARS, YOUR TRAINING WILL PREPARE YOU TO REACH YOUR FUTURE GOALS.< br /><br />WITH CLEARLY DEFINED, INDIVIDUAL MILESTONES, THIS STEP BY STEP PROGRAM WILL LEAD YOU TO SUCCESS ON YOUR OWN INDIVIDUAL CAREER PATH.< br /><br />ENROLL IN THE PROGRAM TODAY, OR BOOK YOUR 1: 1 CALL TO FIND OUT WHAT YOUR NEXT STEPS ARE!  I'M THRILLED TO HAVE YOU ON BOARD, AND I'M LOOKING FORWARD TO STARTING OUR JOURNEY TOWARDS YOUR OWN SUCCESSFUL INDEPENDENT ONLINE BUSINESS.</>)
		]
	}
]

function Quiz({ showQuiz }) {
	const [currentQuestion, setCurrentQuestion] = useState(0)
	const [answers, setAnswers] = useState([])
	const [showReply, setShowReply] = useState(false)
	const [selectedReply, setSelectedReply] = useState('')
	const [userInput, setUserInput] = useState('')
	const [emailBody, setEmailBody] = useState('')
	const [endQuiz, setEndQuiz] = useState(false)

	const quizRef = useRef(null)
	useEffect(() => {
		if (showQuiz && !endQuiz) {
			quizRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}
		
	}, [showQuiz, endQuiz])

	const handleAnswerClick = (answerIndex) => {
		const question = questions[currentQuestion]
		const answer = question.answers[answerIndex] || userInput
		const reply = question.replies.length === 1 ? question.replies[0] : question.replies[answerIndex]

		const newAnswers = [...answers, { question: question.text, answer, reply }]
		setAnswers(newAnswers)
		setSelectedReply(reply)
		if (question.replies.length > 0) {
			setShowReply(true)
		} else {
			handleContinue()
		}
	}

	const handleInputChange = (event) => {
		setUserInput(event.target.value)
	}

	const handleContinue = () => {
		if (currentQuestion < questions.length - 1) {
			setCurrentQuestion(currentQuestion + 1)
			setShowReply(false)
			setUserInput('')  // Reset user input for the next question if needed
		} else {
			setEmailBody('')
			console.log(emailBody)
			console.log("Final Answers:", answers)
		}
	}

	const currentAnswers = questions[currentQuestion].answers
	const isInputField = currentAnswers.length === 0

	if (endQuiz) {
		return (
			<h1 className='text-3xl text-white'>Thank you!</h1>
		)
	}

	return (
		<div className={`w-full max-w-xl bg-white rounded-lg shadow-md overflow-hidden relative transition duration-1000 ${showQuiz && !endQuiz ? 'p-6 ' : 'hidden'}`}>
			<div ref={quizRef} style={{ position: 'absolute', top: -100 }}></div>
			<h1 className="text-xl font-semibold text-gray-800">{questions[currentQuestion].text}</h1>
			<div className="mt-4">
				{currentAnswers.length > 0 ? (
					currentAnswers.map((answer, index) => (
						<button
							key={index}
							onClick={() => handleAnswerClick(index)}
							className="block w-full text-left py-2 px-4 mt-2 text-white bg-gray-400 transition-color duration-100 rounded hover:bg-selectiveGreen focus:outline-none"
						>
							{answer}
						</button>
					))
				) : (
					<input
						type="text"
						value={userInput}
						onChange={handleInputChange}
						placeholder="Type your answer here"
						className="mt-2 p-2 w-full border-2 border-gray-300 rounded"
					/>
				)}
			</div>
			{showReply && (
				<div className="mt-4 p-4 bg-gray-200 rounded">
					<p className="text-gray-800">{selectedReply}</p>
					{currentQuestion === questions.length - 1 ? (
						<button onClick={() => setEndQuiz(true)} className="mt-4 py-2 px-4 bg-selectiveGreen text-white rounded hover:bg-green-600 focus:outline-none">
							Continue
						</button>
					) : (
						<button onClick={handleContinue} className="mt-4 py-2 px-4 bg-selectiveGreen text-white rounded hover:bg-green-600 focus:outline-none">
							Continue
						</button>)}
				</div>
			)}
			{isInputField && (
				<button
					onClick={() => handleAnswerClick()}
					disabled={!userInput}
					className="mt-4 py-2 px-4 bg-selectiveGreen text-white rounded hover:bg-green-600 focus:outline-none"
				>
					Continue
				</button>
			)}
		</div>
	)
}

export default Quiz